import {connect} from 'react-redux'
import {Preview} from 'report-components'
import {getItems, getPatientName, getReportKeyImages} from 'report-components/lib/selectors'
import {getResource} from '../lib'
import {imagesLoaded} from 'report-components/lib/reducers'

const infoItems = getItems()
const signatureItems = getItems()
const fieldItems = getItems()

export const ReportPreview = connect(
  ({report: {isPdfPrinter, lastSaved, finished, reportSettings, reportTitle, reportBasicInfos, reportKeyImages, reportFields, reportSignatures, availableSignatures, dicomInfo}}) =>
    ({
      reportSettings, reportTitle, availableSignatures,
      reportBasicInfos: infoItems(reportBasicInfos),
      reportFields: fieldItems(reportFields),
      reportSignatures: signatureItems(reportSignatures),
      reportKeyImages: getReportKeyImages(reportKeyImages),
      patientName: getPatientName({reportBasicInfos, dicomInfo}),
      finished,
      lastSaved,
      isPdfPrinter,
      getResource: getResource
    }),
  (dispatch) => ({
    setImagesLoaded: (v) => dispatch(imagesLoaded(v))
  })
)(Preview)



// WEBPACK FOOTER //
// ./src/javascripts/report/ReportPreview.jsx